module.exports = __webpack_public_path__ + "img/logo-trx.bebf2e10.png";